import React from 'react';
import { useVersionUpdate } from '../../context/global/VersionUpdateContext';
import { Button } from "../ui";
import { InformationCircle } from '../icons/svg/outline';

/**
 * Version Update Banner Component
 * Displays a banner below the navbar when a new version is available
 * 
 * @component
 * @returns {JSX.Element|null} The banner component or null if no update available
 */
const VersionUpdateBanner = () => {
  const { hasNewVersion, refreshPage } = useVersionUpdate();

  if (!hasNewVersion) {
    return null;
  }

  return (
    <div className="w-full bg-emerald-100 text-emerald-950 py-2 px-4 flex items-center justify-between shadow-md z-40 sticky top-12 border-b border-emerald-950">
      <div className="flex items-center flex-1">
        <InformationCircle className="w-4 h-4 mr-3 flex-shrink-0" />
        <p className="text-xs">
          A new version of the app is available. Please save all work in progress and refresh to get the latest updates.
        </p>
      </div>
      <div className="ml-4">
        <Button
          onClick={refreshPage}
          text="Refresh"
          variant="custom"
          className="px-4 py-1 outline-dashed outline-1 outline-emerald-950 h-4 text-xs hover:bg-emerald-200"
        />
      </div>
    </div>
  );
};

export default VersionUpdateBanner;
